import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { NAV, INSTAGRAM, HANDLE, EMAIL } from "@/data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-espresso text-cream">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10 pt-20 pb-10">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-8 max-w-sm text-[#D9CBBC] leading-relaxed">
            A boutique dessert studio in Clifton Heights, Pennsylvania. Cookies, cupcakes and cheesecake slices, made to order.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.32em] text-gold mb-6">Explore</p>
          <ul className="space-y-3">
            {[...NAV, { to: "/reviews", label: "Reviews" }].map((n) => (
              <li key={n.to}>
                <Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className="link-u text-[#E9DED2] hover:text-cream">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-[11px] uppercase tracking-[0.32em] text-gold mb-6">Studio</p>
          <p className="text-[#E9DED2]">Clifton Heights, PA · Pickup only</p>
          <p className="text-[#CDBBA8] text-sm mt-2">Pickup details are sent once payment is received.</p>
          <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="mt-6 flex items-center gap-3 text-[#E9DED2] hover:text-gold transition-colors">
            <Instagram className="w-4 h-4" strokeWidth={1.4} /> {HANDLE}
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="mt-3 flex items-center gap-3 text-[#E9DED2] hover:text-gold transition-colors break-all">
            <Mail className="w-4 h-4 shrink-0" strokeWidth={1.4} /> {EMAIL}
          </a>
        </div>
      </div>
      <p className="font-display italic text-[16vw] md:text-[11vw] leading-none text-cream/[0.08] mt-16 select-none whitespace-nowrap overflow-hidden">Sugar Studio</p>
      <div className="mt-6 pt-6 border-t border-cream/15 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#CDBBA8]">
        <span>© {new Date().getFullYear()} Lise’s Sugar Studio</span>
        <span>Sweet creations, thoughtfully made.</span>
      </div>
    </div>
  </footer>
);
